import type { PropsWithChildren } from 'react';

export type PropertyListKeyProps = PropsWithChildren;

export function PropertyListKey({ children }: PropertyListKeyProps) {
  return <dt className="text-subtle">{children}</dt>;
}
PropertyListKey.displayName = 'PropertyListKey';
